import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { LISTING_INSTRUCTIONS } from '../constants/queryKeys';
import useAxiosPrivate from './useAxiosPrivate';

export default function useListingInstructionDocument() {
  const axios = useAxiosPrivate();

  const { i18n } = useTranslation();

  async function queryFn(): Promise<Map<string, string>> {
    const res = await axios.get(`/supplier-settings/listing-instruction?locale=${i18n.language}`);
    return new Map(Object.entries(res.data));
  }

  return useQuery({
    queryKey: [LISTING_INSTRUCTIONS],
    queryFn,
  });
}
